var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchDevice10Ports(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 33,
    viewBox: "0 0 200 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14546_162852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.864 1.3645H1.36426V31.3854H197.864V1.3645Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.569908
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 7.1875H8.1875V26.1875H27.1875V7.1875Z",
    stroke: "black",
    strokeWidth: 0.527692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.438 25.927L147.375 25.9272V16.375H106.438V25.927Z",
    stroke: "#231815",
    strokeWidth: 0.142391,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 25.927L106.437 25.9272V16.375H65.5V25.927Z",
    stroke: "#231815",
    strokeWidth: 0.195442,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8551 17.3794H66.8652V22.7756H69.3596V23.706H69.9832V24.4968H72.737V23.706H73.3606V22.7756H75.8551V17.3794Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.633 17.3794H107.644V22.7756H110.138V23.706H110.762V24.4968H113.515V23.706H114.139V22.7756H116.633V17.3794Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1127 23.1838H66.8652V24.1203H69.1127V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.891 23.1838H107.644V24.1203H109.891V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8557 23.1838H73.9834V24.1203H75.8557V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.635 23.1838H114.762V24.1203H116.635V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5939 17.3794H76.791V22.7756H79.2473V23.706H79.8613V24.4968H82.5741V23.706H83.1882V22.7756H85.5939V17.3794Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.372 17.3794H117.569V22.7756H120.027V23.706H120.641V24.4968H123.354V23.706H123.968V22.7756H126.372V17.3794Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8516 23.1838H76.791V24.1203H78.8516V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.63 23.1838H117.569V24.1203H119.63V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7812 23.1838H83.7207V24.1203H85.7812V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.559 23.1838H124.499V24.1203H126.559V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5217 17.3794H86.7188V22.7756H89.175V23.706H89.7904V24.4968H92.5018V23.706H93.1158V22.7756H95.5217V17.3794Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 17.3794H127.496V22.7756H129.954V23.706H130.568V24.4968H133.281V23.706H133.895V22.7756H136.3V17.3794Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7792 23.1838H86.7188V24.1203H88.7792V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.557 23.1838H127.496V24.1203H129.557V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5215 23.1838H93.4609V24.1203H95.5215V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.299 23.1838H134.24V24.1203H136.299V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.259 17.3794H96.4561V22.7756H98.9123V23.706H99.4746V24.4968H102.239V23.706H102.801V22.7756H105.259V17.3794Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.04 17.3794H137.237V22.7756H139.693V23.706H140.257V24.4968H143.02V23.706H143.583V22.7756H146.04V17.3794Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5171 23.1838H96.458V24.1203H98.5171V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.296 23.1838H137.237V24.1203H139.296V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.26 23.1838H103.199V24.1203H105.26V23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.041 23.1838H143.979V24.1203H146.04L146.041 23.1838Z",
    stroke: "#231815",
    strokeWidth: 0.123326,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.631 16.5884V25.7134H157.141V16.5884H167.631Z",
    stroke: "#231815",
    strokeWidth: 0.427174,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.559 18.2521V19.1251H157.025V16.4727H167.746V19.1251H165.135V18.2521V18.1543H165.036H159.657H159.559V18.2521Z",
    stroke: "black",
    strokeWidth: 0.195442
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.174 19.2229H159.479V19.9349H165.174V19.2229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.465 16.5884V25.7134H178.975V16.5884H189.465Z",
    stroke: "#231815",
    strokeWidth: 0.427174,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.393 18.2521V19.1251H178.86V16.4727H189.581V19.1251H186.969V18.2521V18.1543H186.871H181.491H181.393V18.2521Z",
    stroke: "black",
    strokeWidth: 0.195442
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.031 19.2229H181.335V19.9349H187.031V19.2229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.061 24.5091C193.424 24.5091 193.718 24.2157 193.718 23.8536C193.718 23.4916 193.424 23.198 193.061 23.198C192.7 23.198 192.406 23.4916 192.406 23.8536C192.406 24.2157 192.7 24.5091 193.061 24.5091Z",
    stroke: "black",
    strokeWidth: 0.195442
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11385_24082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 33,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchDevice10Ports);
export default __webpack_public_path__ + "static/media/switch-device-10-ports.f75a0ca30d7e7f0cb8c83af7bad5a571.svg";
export { ForwardRef as ReactComponent };